const formatter = new Intl.NumberFormat('en-GB', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: 'currency',
    currency: 'GBP'
});
export default formatter;
